import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
import { SidebarUserComponent } from 'projects/shared/lib/components/shared/sidebar/user/sidebar-user.component';
import { ToastItem } from 'projects/shared/lib/components/shared/toast/item/toast-item.model';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { IUserSwitchCustomerDialogService } from 'shared/interfaces/services/dialogs/user-switch-customer-dialog-service.abstract';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar-user',
  imports: [
    RouterModule
  ],
  templateUrl: './sidebar-user.component.html',
  styleUrls: ['./sidebar-user.component.scss']
})
export class SidebarUserMHComponent extends SidebarUserComponent {
  public isMultiCustomerUser: boolean;
  public isUserAdmin: boolean;

  private userPermissionSubscription: Subscription | undefined;

  public constructor() {
    super();

    this.isMultiCustomerUser = this.authService.isMultiCustomerUser();
    this.isUserAdmin = this.authService.isUserAdmin();
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.userPermissionSubscriptionInit();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();

    this.userPermissionSubscription?.unsubscribe();
  }

  private userPermissionSubscriptionInit() {
    if (!this.userPermissionSubscription) {
      this.userPermissionSubscription = this.authService.userPermissionChangedGet().subscribe(
        () => {
          this.isMultiCustomerUser = this.authService.isMultiCustomerUser();
          this.isUserAdmin = this.authService.isUserAdmin();
        }
      );
    }
  }

  public logout() {
    this.userService.userLogout().subscribe({
      next: () => {
        this.authService.accessJWTClear();

        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Success,
          title: $localize`:@@NavTopMenuLogoutSuccessToastTitle:Logout successful`,
        }));

        this.router.navigate([this.anonymousLandingPage.routerlink], { queryParams: this.anonymousLandingPage.queryParams });
      },
      error: (error) => {
        this.logger.error(error, this.constructor.name);
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Danger,
          title: $localize`:@@NavTopMenuLogoutErrorToastTitle:Logout failed`,
          code: JSON.parse(error.response).errorCode
        }));
      },
      complete: () => { }
    });
  }

  public switchUserDialogShow() {
    ServiceLocator.injector.get(IUserSwitchCustomerDialogService).userSwitchCustomerDialogShow(
      () => { },
    );
  }

}
